webpackJsonp([0],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {__webpack_require__(2);
__webpack_require__(1);
__webpack_require__(5);
__webpack_require__(29);
__webpack_require__(6);

module.exports = angular.module('PwnFMSubscriptionApp', ['ngSanitize', 'PwnFMGateServices', 'PwnFMGateConstants'])
.config( ['emailFromProcessorProvider', function(emailFromProcessorProvider) {
    emailFromProcessorProvider.setFmgateData({list:'exwwuprryf', keytype:'pwn', pochodzenie:'wstronenieba.pwn.pl', zrodlo:'pobranie ebooka', zgody_tryb:'auto'});
}])
.directive('pwnFmSubscriptionDialogs', function() {
    return {
        templateUrl: pwnFmsubscriptionApp.vendorBaseURL + '/fm_subscription/jstpl/fmSubscriptionDialogs.tpl.html',
        controller: [ '$scope', '$element', '$attrs', '$window', '$sce', 'emailFromProcessor', 'FMSubscriberStates', 'ModalAlerts', 'BranchesOfScience', function( $scope, $element, $attrs, $window, $sce, emailFromProcessor, FMSubscriberStates, ModalAlerts, BranchesOfScience ) {
            
            $scope.baseURL = pwnFmsubscriptionApp.vendorBaseURL;
            $scope.downloadPage = pwnFmsubscriptionApp.naDownloadPage;
            $scope.emailModalSpinner = false;
            $scope.unsubscribedModalSpinner = false;
            $scope.specializationModalSpinner = false;
            $scope.modalAlert = '';

            $scope.formSubmitted = false;
            
            $scope.zgodyPWN = {
                zgodaPS: zgodyPwn.zgoda_p_s,
                zgodaOS: zgodyPwn.zgoda_o_s,
                zgodaP: zgodyPwn.zgoda_p,
                zgodaO: zgodyPwn.zgoda_o,
                adminInfo:  $sce.trustAsHtml(zgodyPwn.admin_info)
            }

            $element.find('#zgoda_o_chck').find('[data-toggle="tooltip"]').tooltip({
                placement: 'bottom',
                title: $scope.zgodyPWN.zgodaO
            });
            $element.find('#zgoda_p_chck').find('[data-toggle="tooltip"]').tooltip({
                placement: 'bottom',
                title: $scope.zgodyPWN.zgodaP
            });
            $element.find('.modal').on('hide.bs.modal', function (e) {
                e.stopPropagation();
                jQuery('body').css('padding-right','');
            });
            
            $scope.branchesOfScience = BranchesOfScience;
            
            var edition = '';
            var jqEmailModal = $element.find('#fmSubscriptionEmailModal');
            var jqAlertModal = $element.find('#fmSubscriptionAlertModal');
            var jqUnsubscribedModal = $element.find('#fmUnsubscribedModal');
            var jqSpecializationModal = $element.find('#fmSpecializationModal');
            
            $scope.subscriber = {
                email: '',
                zgoda_p: false,
                zgoda_o: false
            }
            
            jqEmailModal.on('show.bs.modal', function(event) {
                var button = angular.element(event.relatedTarget);
                edition = button.data('edition') // Extract info from data-* attributes
            });
            
            jqEmailModal.on('hidden.bs.modal', function() {
                
            });

            $scope.downloadRedirect = function( edition ) {
                var downloadURL = $scope.downloadPage.concat('?email=', $scope.subscriber.email);
                if(edition) downloadURL = downloadURL.concat('&edition=', edition);
                $window.location.href = downloadURL;
            }
            
            $scope.submitEmailForm = function() {
                
                //if( !edition ) return;
                $scope.formSubmitted = true;
                if( $scope.fmSubscriptionEmailForm.$invalid ) return;
                
                $scope.emailModalSpinner = true;
                //console.log('submit %d', edition);
                //console.log($scope.subscriber);
                emailFromProcessor.launch($scope.subscriber.email).then(function(response) {
                    
                    if(response.action == 'branch_of_science_needed') {
                        $scope.emailModalSpinner = false;
                        jqEmailModal.modal('hide');
                        jqSpecializationModal.modal('show');
                    }
                    
                    if( response.action == "check_existing_subscriber" ) {
                        /*
                        response.action = "check_existing_subscriber"
                        response.fmSubscriberData = {...}
                        response.fmSubscriberData.state = ...
                        response.alert
                         */
                        var subscriber_state = parseInt(response.fmSubscriberData.state);
                        if( subscriber_state == FMSubscriberStates.SUBSCRIBER_STATUS_ACTIVE ) {
                            
                            if( !response.fmSubscriberData['dziedzina naukowa'] ) {
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                jqSpecializationModal.modal('show');
                                
                            } else {
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                //DOWNLOA ALLOWED
                                //ga('send', 'event', 'subskrypcja', 'pobranie', 'fm status: aktywny');
                                $scope.downloadRedirect( edition );
                            }
                            
                        } else if( subscriber_state == FMSubscriberStates.SUBSCRIBER_STATUS_UNSUBSCRIBED ) {
                            $scope.emailModalSpinner = false;
                            jqEmailModal.modal('hide');
                            $scope.modalAlert = ModalAlerts.UNSUBSCRIBED;
                            //ga('send', 'event', 'formularze', 'wypełnienie', 'fm status: wypisany');
                            jqUnsubscribedModal.modal('show');
                            
                        } else if( subscriber_state == FMSubscriberStates.SUBSCRIBER_STATUS_UNCONFIRMED ) {
                            
                            emailFromProcessor.resendActivationLink(edition)
                            .then( function(response) {
                                
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                
                                if( response.status = 'OK' ) {
                                    
                                    $scope.modalAlert = ModalAlerts.UNCONFIRMED;
                                    //ga('send', 'event', 'formularze', 'wypełnienie', 'fm status: do aktywacji');
                                    jqAlertModal.modal('show');
                                    
                                } else {
                                    $scope.modalAlert = ModalAlerts.UNEXPECTED_ERROR;
                                    jqAlertModal.modal('show');
                                }
                                
                            }, function(response) {
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                                jqAlertModal.modal('show');
                            });
                            
                        } else if( subscriber_state == FMSubscriberStates.SUBSCRIBER_STATUS_UNACTIVE ) {
                            
                            emailFromProcessor.addUnactive(edition)
                            .then(function(response) {
                                
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                
                                if( response.status = 'OK' ) {
                                    $scope.modalAlert = ModalAlerts.UNCONFIRMED;
                                    //ga('send', 'event', 'formularze', 'wypełnienie', 'fm status: nie aktywowany');
                                    jqAlertModal.modal('show');
                                } else {
                                    $scope.modalAlert = ModalAlerts.UNEXPECTED_ERROR;
                                    jqAlertModal.modal('show');
                                }
                                
                            }, function(response) {
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                                jqAlertModal.modal('show');
                            });
                    
                        } else {
                            // SUBSCRIBER BOUNCED
                            $scope.emailModalSpinner = false;
                            jqEmailModal.modal('hide');
                            $scope.modalAlert = ModalAlerts.BOUNCED;
                            //ga('send', 'event', 'formularze', 'wypełnienie', 'fm status: odbijający');
                            jqAlertModal.modal('show');
                        }
                        
                    }
                    
                }, function(response) {
                    jqEmailModal.modal('hide');
                    $scope.emailModalSpinner = false;
                    //Wyświetl dialog o błędzie
                    $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                    jqAlertModal.modal('show');
                });
                
            }
            
            $scope.submitSpecializationForm = function() {
                
                $scope.specializationModalSpinner = true;
                if( $scope.fmBranchOfScienceForm.$invalid ) return;
                var fmSubscriberData = emailFromProcessor.getFmSubscriberData();
                
                if( parseInt(fmSubscriberData.state) == FMSubscriberStates.SUBSCRIBER_STATUS_ACTIVE ) {
                    
                    emailFromProcessor.updateSubscriberCustom('dziedzina_naukowa', $scope.subscriber.branchOfScience, edition)
                    .then( function(update_response) {
                        $scope.specializationModalSpinner = false;
                        jqSpecializationModal.modal('hide');
                        
                        //DOWNLOAD ALLOWED
                        //ga('send', 'event', 'subskrypcja', 'pobranie', 'status: aktywny');
                        $scope.downloadRedirect( edition );
                        
                    }, function(update_response) {
                        $scope.specializationModalSpinner = false;
                        jqSpecializationModal.modal('hide');
                        $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                        jqAlertModal.modal('show');
                    });
                }
                
                /* SUBSKRYBENT NIE ISTNIEJE */
                if( angular.equals({}, fmSubscriberData ) ) {
                    emailFromProcessor.addFmSubscriber($scope.subscriber.email, $scope.subscriber.branchOfScience, edition).then(function( add_response ) {

                        if( add_response.data.status == "OK" ) {
                            $scope.specializationModalSpinner = false;
                            jqSpecializationModal.modal('hide');
                            $scope.modalAlert = ModalAlerts.ADDED;
                            jqAlertModal.modal('show');
                        }

                    }, function( add_response ) {

                        $scope.specializationModalSpinner = false;
                        jqSpecializationModal.modal('hide');
                        $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                        jqAlertModal.modal('show');

                    });
                }
                
            }
            
            $scope.submitUnsubscribedForm = function() {
                
                $scope.unsubscribedModalSpinner = true;
                emailFromProcessor.resubscribe( edition ).then(function( response ) {
                    
                    
                    jqUnsubscribedModal.modal('hide');
                    
                    if(response.data.status == 'OK') {
                        
                        //DOWNLOAD ALLOWED
                        //ga('send', 'event', 'subskrypcja', 'pobranie', 'status: aktywny, reaktywacja');
                        $scope.downloadRedirect( edition );
                        
                    } else {
                        $scope.unsubscribedModalSpinner = false;
                        $scope.modalAlert = ModalAlerts.UNEXPECTED_ERROR;
                        jqAlertModal.modal('show');
                    }
                    
                }, function( response ) {
                    
                    $scope.unsubscribedModalSpinner = false;
                    jqUnsubscribedModal.modal('hide');
                    $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                    jqAlertModal.modal('show');
                    
                });
            }
        }]
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {__webpack_require__(2);
__webpack_require__(1);
__webpack_require__(5);
__webpack_require__(3);
__webpack_require__(7);
__webpack_require__(4);
__webpack_require__(10);
__webpack_require__(8);

module.exports = angular.module('WstroneniebaApp',['ngSanitize', 'ThemeFunctions', 'ModalsData', 'AnimationsData', 'PwnFMSubscriptionApp'])
.directive('modalThumbnails', ['modals_data', 'modalService', function( modals_data, modalService ) {
    return {
        templateUrl: 'tpl/modal-thumbnails.html',
        controller: ['$scope', '$element', '$attrs', function( $scope, $element, $attrs ) {
            $scope.modals_data = modals_data;
            $scope.setCurrentModal = function(modal_id) {
                modalService.setCurrentModal( modal_id );
            }
        }],
        scope: {}
    }
}])
.directive('animationThumbnails', ['animations_data', function( animations_data ) {
    return {
        templateUrl: 'tpl/animation-thumbnails.html',
        controller: ['$scope', '$element', '$attrs', function( $scope, $element, $attrs ) {
            $scope.animations_data = animations_data;
        }],
        scope: {}
    }
}])
.directive('modalWindow', ['modalService', 'modals_data', function( modalService, modals_data ) {
    return {
        templateUrl: 'tpl/modal-windows.html',
        controller: ['$scope', '$element', '$attrs', function( $scope, $element, $attrs ) {
            $scope.modals_data = modals_data;
            $scope.modalService = modalService;
        }],
        scope: {}
    }
}])
.directive('downloadGiftBut',
    function() {
        return {
            link: function( scope, element, attrs ) {
                element.on('click', function() {
                    jQuery('#fmSubscriptionEmailModal').modal('show');
                })
            }
        }
    }
);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.6.10
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isArray;
var isDefined;
var lowercase;
var noop;
var nodeContains;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to properly escaped html string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The whitelist for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
 *   `$compileProvider`}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var hasBeenInstantiated = false;
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    hasBeenInstantiated = true;
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidElements
   * @kind function
   *
   * @description
   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
   * and are not stripped off during sanitization. You can extend the following lists of elements:
   *
   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
   *   elements. HTML elements considered safe will not be removed during sanitization. All other
   *   elements will be stripped off.
   *
   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
   *   "void elements" (similar to HTML
   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
   *   elements have no end tag and cannot have content.
   *
   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
   *   `$sanitize`.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the elements you add.
   * </div>
   *
   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
   *   more of the following properties:
   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     HTML elements.
   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     void HTML elements; i.e. elements that do not have an end tag.
   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
   *     elements. The list of SVG elements is only taken into account if SVG is
   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
   *
   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
   *
   * @return {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidElements = function(elements) {
    if (!hasBeenInstantiated) {
      if (isArray(elements)) {
        elements = {htmlElements: elements};
      }

      addElementsTo(svgElements, elements.svgElements);
      addElementsTo(voidElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlElements);
    }

    return this;
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidAttrs
   * @kind function
   *
   * @description
   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
   * not stripped off during sanitization.
   *
   * **Note**:
   * The new attributes will not be treated as URI attributes, which means their values will not be
   * sanitized as URIs using `$compileProvider`'s
   * {@link ng.$compileProvider#aHrefSanitizationWhitelist aHrefSanitizationWhitelist} and
   * {@link ng.$compileProvider#imgSrcSanitizationWhitelist imgSrcSanitizationWhitelist}.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the attributes you add.
   * </div>
   *
   * @param {Array<String>} attrs - A list of valid attributes.
   *
   * @returns {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidAttrs = function(attrs) {
    if (!hasBeenInstantiated) {
      extend(validAttrs, arrayToMap(attrs, true));
    }
    return this;
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isArray = angular.isArray;
  isDefined = angular.isDefined;
  lowercase = angular.lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
    // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = stringToMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = stringToMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = stringToMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');

  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function stringToMap(str, lowercaseKeys) {
    return arrayToMap(str.split(','), lowercaseKeys);
  }

  function arrayToMap(items, lowercaseKeys) {
    var obj = {}, i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  function addElementsTo(elementsMap, newElements) {
    if (newElements && newElements.length) {
      extend(elementsMap, arrayToMap(newElements));
    }
  }

  /**
   * Create an inert document that contains the dirty HTML that needs sanitizing
   * Depending upon browser support we use one of three strategies for doing this.
   * Support: Safari 10.x -> XHR strategy
   * Support: Firefox -> DomParser strategy
   */
  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
    var inertDocument;
    if (document && document.implementation) {
      inertDocument = document.implementation.createHTMLDocument('inert');
    } else {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');

    // Check for the Safari 10.1 bug - which allows JS to run inside the SVG G element
    inertBodyElement.innerHTML = '<svg><g onload="this.parentNode.remove()"></g></svg>';
    if (!inertBodyElement.querySelector('svg')) {
      return getInertBodyElement_XHR;
    } else {
      // Check for the Firefox bug - which prevents the inner img JS from being sanitized
      inertBodyElement.innerHTML = '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">';
      if (inertBodyElement.querySelector('svg img')) {
        return getInertBodyElement_DOMParser;
      } else {
        return getInertBodyElement_InertDocument;
      }
    }

    function getInertBodyElement_XHR(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        html = encodeURI(html);
      } catch (e) {
        return undefined;
      }
      var xhr = new window.XMLHttpRequest();
      xhr.responseType = 'document';
      xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
      xhr.send(null);
      var body = xhr.response.body;
      body.firstChild.remove();
      return body;
    }

    function getInertBodyElement_DOMParser(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
        body.firstChild.remove();
        return body;
      } catch (e) {
        return undefined;
      }
    }

    function getInertBodyElement_InertDocument(html) {
      inertBodyElement.innerHTML = html;

      // Support: IE 9-11 only
      // strip custom-namespaced attributes on IE<=11
      if (document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }

      return inertBodyElement;
    }
  })(window, window.document);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }

    var inertBodyElement = getInertBodyElement(html);
    if (!inertBodyElement) return '';

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // trigger mXSS if it is going to happen by reading and writing the innerHTML
      html = inertBodyElement.innerHTML;
      inertBodyElement = getInertBodyElement(html);
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
        if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = getNonDescendant('nextSibling', node);
        if (!nextNode) {
          while (nextNode == null) {
            node = getNonDescendant('parentNode', node);
            if (node === inertBodyElement) break;
            nextNode = getNonDescendant('nextSibling', node);
            if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = getNonDescendant('nextSibling', node);
    }
  }

  function getNonDescendant(propName, node) {
    // An element is clobbered if its `propName` property points to one of its descendants
    var nextNode = node[propName];
    if (nextNode && nodeContains.call(node, nextNode)) {
      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
    }
    return nextNode;
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', [])
  .provider('$sanitize', $SanitizeProvider)
  .info({ angularVersion: '1.6.10' });

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {__webpack_require__(1);
__webpack_require__(6);

module.exports = angular.module('PwnFMGateServices', ['PwnFMGateConstants'])
.provider('emailFromProcessor', function() {
    
    var $_http;
    var $_q;
    var $_filter;
    var _FMSubscriberStates;
    var _ModalAlerts;
    
    var apiURL = 'https://lp.pzwl.pl/fm/fmgate.php';
    var list = '';
    var keytype = '';
    var state = '';
    var pochodzenie = '';
    var zrodlo = '';
    var zgody_tryb = '';
    
    var fmSubscriberData = {};
    
    var ret = {
        launch: function( email ) {
            
            var d = $_q.defer();
            
            ret.getSubscriberInfo( email ).then(function( response ) {
                
                if( response.data.errors && response.data.errors.length ) {
                    
                    /* SUBSCRIBER DOES NOT EXIST */
                    if( response.data.errors[0].code == 1311 ) {
                        
                        fmSubscriberData = {};
                        d.resolve({action:'branch_of_science_needed'});
                    }
                        
                } else {
                    
                    /* SUBSCRIBER EXISTS */
                    var fmdata = response.data.data;
                    
                    ret.loadFmSubscriberData(fmdata);
                    
                    d.resolve({ action:'check_existing_subscriber', fmSubscriberData: fmSubscriberData });
                }
                
            }, function( response ) {
                
                d.reject( response );
                
            });
            
            return d.promise;
        },
        getSubscriberInfo: function( email ) {
            
            if(!list) return;
            
            return $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    list: list,
                    keytype: keytype,
                    email: email,
                    request: 'subscriber/get'
                }
            });
        },
        getFmSubscriberData: function() {
            
            return fmSubscriberData;
        },
        setFmSubscriberData: function( subscriber_data ) {
            
            fmSubscriberData = anular.extend({}, subscriber_data);
            
        },
        loadFmSubscriberData: function( fmdata ) {
            
            fmSubscriberData = {};
            fmSubscriberData.state = fmdata.state;
            fmSubscriberData.email = fmdata.email;
            fmSubscriberData.pochodzenie = ret.getCustomFieldValue( 'pochodzenie', fmdata );
            fmSubscriberData["źródło"] = ret.getCustomFieldValue( 'źródło', fmdata );
            fmSubscriberData.zgoda_tele = ret.getCustomFieldValue( 'zgoda_tele', fmdata );
            fmSubscriberData.query_string = ret.getCustomFieldValue( 'query_string', fmdata );
            fmSubscriberData["dziedzina naukowa"] = ret.getCustomFieldValue( 'dziedzina naukowa', fmdata );
            fmSubscriberData.telefon = ret.getCustomFieldValue( 'telefon', fmdata );
            
        },
        getCustomFieldValue: function( cfkey, fmdata ) {
            
            return $_filter( 'filter' )( fmdata.custom_fields, { field: cfkey } )[0].value;
            
        },
        addFmSubscriber: function( email, branch_of_science, na_edition ) {
            
            return $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    list: list,
                    request: 'subscriber/add',
                    keytype: keytype,
                    email: email,
                    pochodzenie: pochodzenie,
                    zrodlo: zrodlo,
                    zgody_tryb: zgody_tryb,
                    zgoda_p: 1,
                    zgoda_o: 1,
                    dziedzina_naukowa: branch_of_science,
                    pobierz_wydanie: na_edition
                }
            });
        },
        updateSubscriberCustom: function(customKey, customValue, na_edition) {
            var data = {
                list: list,
                request: 'subscriber/edit',
                keytype: keytype,
                email: fmSubscriberData.email,
                pochodzenie: pochodzenie,
                zrodlo: zrodlo,
                zgody_tryb: zgody_tryb,
                pobierz_wydanie: na_edition
            }
            
            data[customKey] = customValue;
            
            return $_http({
                url: apiURL,
                method: 'POST',
                data: data
            });
        },
        resubscribe: function(na_edition) {
            return $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    request: 'subscriber/edit',
                    list: list,
                    keytype: keytype,
                    email: fmSubscriberData.email,
                    state: _FMSubscriberStates.SUBSCRIBER_STATUS_ACTIVE,
                    zgody_tryb: zgody_tryb,
                    pobierz_wydanie: na_edition
                }
            });
        },
        addUnactive: function(na_edition) {
            return $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    request: 'subscriber/add',
                    list: list,
                    keytype: keytype,
                    email: fmSubscriberData.email,
                    pochodzenie: fmSubscriberData.pochodzenie,
                    zgody_tryb: zgody_tryb,
                    zgoda_p: 1,
                    zgoda_o: 1,
                    pobierz_wydanie: na_edition
                }

            });
        },
        resendActivationLink: function(na_edition) {
            
            var d = $_q.defer();
            
            $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    request: 'subscriber/edit',
                    list: list,
                    keytype: keytype,
                    email: fmSubscriberData.email,
                    state: _FMSubscriberStates.SUBSCRIBER_STATUS_UNACTIVE,
                    zgody_tryb: zgody_tryb
                }
            }).then(function( response ) {
                
                if( response.data.status == 'OK' ) {
                    
                    ret.addUnactive(na_edition).then(function( response ) {
                        
                        if( response.data.status == 'OK' ) {
                            
                            d.resolve({status: 'OK'});
                        }
                        
                    }, function( response ) {
                        
                        d.reject({status: response.data.status});
                        
                    });
                    
                } else {
                    
                    d.reject({status: response.data.status});
                }
                
            }, function( response ) {
                
                d.reject( response );
                
            });
            
            return d.promise;
        }
    };
    
    return {
        setFmgateData: function( config ) {
            list = config.list;
            keytype = config.keytype;
            pochodzenie = config.pochodzenie;
            zgody_tryb = config.zgody_tryb;
            zrodlo = config.zrodlo;
            return this;
        },
        $get: ['$http', '$q', '$filter', 'FMSubscriberStates', 'ModalAlerts', function($http, $q, $filter, FMSubscriberStates, ModalAlerts) {
            _FMSubscriberStates = FMSubscriberStates;
            _ModalAlerts = ModalAlerts;
            $_http = $http;
            $_q = $q;
            $_filter = $filter;
            return ret;
        }]
    }
    
}).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.defaults.transformRequest = function(data){
    if (data === undefined) {
      return data;
    }
    return jQuery.param(data);
  };
  $httpProvider.defaults.headers.post['Content-Type'] = ''
    + 'application/x-www-form-urlencoded; charset=UTF-8';
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(13);
module.exports = 'ngSanitize';


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);

module.exports = angular.module('PwnFMGateConstants', [])
.constant('FMSubscriberStates', {
    SUBSCRIBER_STATUS_ACTIVE: 1,
    SUBSCRIBER_STATUS_UNCONFIRMED: 2,
    SUBSCRIBER_STATUS_UNACTIVE: 3,
    SUBSCRIBER_STATUS_UNSUBSCRIBED: 4,
    SUBSCRIBER_STATUS_SOFT_BOUNCED: 5,
    SUBSCRIBER_STATUS_HARD_BOUNCED: 8
})
.constant('ModalAlerts', {
    UNCONFIRMED: 'Dziękujemy! Na podany adres e-mail przesłaliśmy wiadomość z linkiem do pobrania materiału.',
    UNACTIVE: 'Nie aktywowany',
    UNSUBSCRIBED: 'Ten adres e-mail znajdował się już w systemie. Jednak nasz system odnotował, kliknięcie w link oznaczający, że nie chcesz już otrzymywać od nas żadnej korespondencji. Oznacza to również rezygnację z bezpłatnych wydań Niezbędnika. Czy chcesz otrzymywać od nas korespondencję?',
    BOUNCED: 'Niestety! podany przez Ciebie adres e-mail nie przyjmował wiadomości od nas. Spróbuj proszę podać inny adres.',
    ADDED: 'Na podany adres wysłano link aktywacyjny, prosimy o sprawdzenie szkrzynki i dokonanie aktywacji',
    REQUEST_ERROR: 'Chwilowe przeciążenie sieci. Spróbuj jeszcze raz',
    UNEXPECTED_ERROR: 'Wystąpił niespodziewany błądy. Spróbuj jeszcze raz'
})
.constant('BranchesOfScience', [
    'Biotechnologia medyczna',
    'Biotechnologia przemysłowa',
    'Biotechnologia rolnicza',
    'Biotechnologia środowiskowa',
    'Ekonomia i biznes',
    'Elektrotechnika, elektronika, inżyniera informatyczna',
    'Filozofia etyka i religia',
    'Geografia społeczna i gospodarcza',
    'Historia i archeologia',
    'Inne',
    'Inżynieria chemiczna',
    'Inżynieria lądowa',
    'Inżynieria mechaniczna',
    'Inżynieria medyczna',
    'Inżynieria środowiska',
    'Języki i literatura',
    'Matematyka',
    'Media i komunikowanie',
    'Medycyna kliniczna',
    'Medycyna ogólna',
    'Nanotechnologia',
    'Nauka o zdrowiu',
    'Nauka o zwierzętach i mleczarstwie',
    'Nauki biologiczne',
    'Nauki chemiczne',
    'Nauki fizyczne',
    'Nauki o komputerach i informatyka',
    'Nauki o ziemi i o środowisku',
    'Nauki polityczne',
    'Nauki weterynaryjne',
    'Pedagogika',
    'Prawo',
    'Psychologia',
    'Rolnictwo, leśnictwo i rybołówstwo',
    'Socjologia',
    'Sztuka (sztuka, historia sztuki, sztuki sceniczne, muzyka)'
]);

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);
module.exports = angular.module('ModalsData',[])
.constant('modals_data',[
    {
        modal_id: 'barwy-nieba-1',
        title: '1. Barwy nieba z dużej wysokości',
        thumbnail: 'img/ilustracje/barwy-nieba-2-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/barwy-nieba-2-1100x576.jpg',
                description: ['Taki widok widziałeś już wielokrotnie w okienku samolotu. Czy zwróciłeś jednak uwagę na barwę nieba? Jest nieporównanie ciemniejsze niż to, które widzimy z powierzchni Ziemi. Jeśli spojrzysz wysoko, a nie poziomo, jak na zdjęciu, to tam jest ono już ciemnogranatowe.']
            },
            {
                image: 'img/ilustracje/barwy-nieba-2a-1100x620.jpg',
                description: [ 'Oglądane z wysokości 30 km, jaką osiągają niektóre balony, jest ono jeszcze ciemniejsze – już prawie czarne, jak na zdjęciu poniżej (źródło: <a href="http://jwastronomy.com/Stratos">jwastronomy.com/Stratos</a>). Film: <a href="https://youtube.com/watch?v=KnxvS9XFJnE">youtube.com/watch?v=KnxvS9XFJnE</a>, przedstawia podróż do granic kosmosu zrealizowaną przez amatorów. Pomysł, jego wykonanie i rezultat:  film – z którego pochodzi zdjęcie – budzą zazdrość.']
            }
        ]
    },
    {
        modal_id: 'barwy-nieba-3',
        title: '2. Barwy nieba z powierzchni Ziemi',
        thumbnail: 'img/ilustracje/barwy-nieba-3-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/barwy-nieba-3.jpg',
                description: ['Takie barwy ma niebo oglądane w pogodny dzień z powierzchni Ziemi: blado-błękitne (niemal białe) w pobliżu horyzontu, ciemnoniebieskie w zenicie.']
            }
        ]
    },
    {
        modal_id: 'wielkosc-widnokregu',
        title: '3. Wielkość widnokręgu',
        thumbnail: 'img/ilustracje/wielkosc-widnokregu-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/wielkosc-widnokregu-1100x325.jpg',
                description: ['Wielkość powierzchni Ziemi, którą widzimy, zależy od wysokości, z której patrzymy. Gdy wysokość jest znikoma w stosunku do promienia Ziemi, widziany fragment powierzchni Ziemi można uznać za płaski.']
            }
        ]
    },
    {
        modal_id: 'na-pomoc-wyobrazni-1',
        title: '4. Na pomoc wyobraźni – globus i dysk CD',
        thumbnail: 'img/ilustracje/na-pomoc-wyobrazni-1-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/na-pomoc-wyobrazni-1.jpg',
                description: ['Dyskietkę przyklejoną do globusa w miejscu, w którym przebywamy, można traktować jak przedłużenie fragmentu powierzchni Ziemi, który widzimy. Jest ona zarazem fragmentem płaszczyzny horyzontu – nieskończonej płaszczyzny stycznej do Ziemi w miejscu obserwacji. Użycie takiego prostego zestawu, lub choćby tylko jego wyobrażenie, pozwala zrozumieć wpływ obecności Ziemi pod naszymi stopami i jej ruchu na to, co widzimy ponad głową.']
            }
        ]
    },
    {
        modal_id: 'na-pomoc-wyobrazni-2',
        title: '5. Na pomoc wyobraźni – listewka i kartonik',
        thumbnail: 'img/ilustracje/na-pomoc-wyobrazni-2-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/na-pomoc-wyobrazni-2-1095x547.jpg',
                description: ['Tak prymitywny zestaw: listewka spełniająca rolę osi obrotu Ziemi, tekturka wyobrażająca płaszczyznę horyzontu i długa nitka wskazująca kierunek do obiektu, pozwala doskonale zaprezentować sytuację ziemskiego obserwatora nieba i ruchu bardzo dalekich obiektów. Pozwala zrozumieć zależność toru ruchu obiektów względem horyzontu od kierunku, w którym je widzimy.']
            }
        ]
    },
    {
        modal_id: 'poludnik-niebieski',
        title: '6. Południk niebieski',
        thumbnail: 'img/ilustracje/poludnik-niebieski-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/poludnik-niebieski-1097x928.jpg',
                description: ['Płaszczyzna przechodząca przez środek Ziemi i miejsce obserwacji jest, zgodnie z definicją geografów, płaszczyzną południka miejscowego. Jej przedłużenie (wyróżnione na rysunku żółtym kolorem) astronomowie nazwali południkiem niebieskim. W płaszczyźnie południka miejscowego i niebieskiego jest położona oś obrotu Ziemi i sfery nieba. Szczególne znaczenie tej płaszczyzny polega na tym, że poruszające się na skutek obrotu Ziemi odległe pozaziemskie obiekty, przechodząc przez tę płaszczyznę, osiągają największą lub najmniejszą wysokość ponad horyzontem. ']
            }
        ]
    },
    {
        modal_id: 'sezonowe-zmiany-nieba',
        title: '7. Sezonowe zmiany nieba',
        thumbnail: 'img/ilustracje/sezonowe-zmiany-nieba-thumb.jpg',
        images: [
            { 
                image: 'img/ilustracje/sezonowe-zmiany-nieba-1097x1097.jpg',
                description: ['Widok na położenie obserwatora znajdującego się w pobliżu równika, o północy, na początku września i w końcu października. Słońce jest poza rysunkiem, na dole. Kolorem niebieskim, zielonym i pomarańczowym są zaznaczone kierunki do trzech gwiazd położonych w płaszczyźnie rysunku. Wcześniej (z prawej strony), o północy, w pobliżu zenitu znajdowała się gwiazda, którą wskazuje linia niebieska. Po upływie około miesiąca, o północy, w okolicach zenitu będzie widoczna gwiazda wskazywana linią zieloną. Jeszcze później (po około dwóch tygodniach) będzie tam widoczna gwiazda, w stronę której jest skierowana linia pomarańczowa.']
            }
        ]
    },
    {
        modal_id: 'orbita-ziemi',
        title: '8. Orbita Ziemi jako kalendarz',
        thumbnail: 'img/ilustracje/orbita-ziemi-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/orbita-ziemi-1095x1061-p.jpg',
                description: [
                    'Widok z kierunku prostopadłego do płaszczyzny orbity Ziemi objaśniający przyczyny występowania pór roku. Gwiazdy widoczne w tle znajdują się daleko poza orbitą Ziemi i przypominają o konkretnej, ściśle określonej orientacji osi obrotu Ziemi względem gwiazd.', 
                    'Przyczyną pór roku jest stały kierunek osi obrotu Ziemi względem gwiazd, jej nachylenie do płaszczyzny orbity oraz wokółsłoneczny ruch Ziemi. Skutkiem tych okoliczności są ciągłe zmiany kąta pomiędzy kierunkiem osi obrotu Ziemi i kierunkiem do Słońca powodujące zmiany nasłonecznienia każdego miejsca Ziemi. Zwróć uwagę na fakt, iż każdemu momentowi roku odpowiada ściśle określone położenie Ziemi na orbicie. Zastanów się, czy coś by się zmieniło w stosunku do obecnego stanu, gdyby Ziemia obiegała Słońce w przeciwną stronę niż teraz?'
                ]
            }
        ]
    },
    {
        modal_id: 'lato-i-zima',
        title: '9. Lato i Zima',
        thumbnail: 'img/ilustracje/lato-i-zima-thumb.jpg',
        images: [
            { 
                image: 'img/ilustracje/lato-i-zima-1197x598.jpg',
                description: [
                    'Widok na Ziemię około 21 czerwca i 21 grudnia z kierunku prostopadłego do prostej łączącej te położenia Ziemi. Słońce znajduje się w środku, pomiędzy obiema częściami rysunku. 21 czerwca w południe każdy mieszkaniec północnej półkuli Ziemi zaobserwuje największą w ciągu roku wysokość Słońca (jest początek lata), mieszkaniec półkuli południowej zaś najmniejszą (początek zimy). 21 grudnia sytuacja jest odwrotna.',
                    'W wyróżnionych miejscach Ziemi jest narysowane położenie horyzontu w momencie południa i podana jest wysokość Słońca ponad nim. Kąt nachylenia osi obrotu Ziemi do płaszczyzny orbity określa graniczne szerokości geograficzne tych obszarów Ziemi, w których Słonce może być widoczne w zenicie (granice tego obszaru stanowią tzw. zwrotniki), oraz tych obszarów, w których występują doby bez wschodu Słońca lub doby, podczas których Słońce nie zachodzi (granice tego obszaru stanowią tzw. koła podbiegunowe). Rysunek ujawnia też przyczynę różnic długości trwania dnia w zależności od daty i miejsca na Ziemi.'    
                ]
            }
        ]
        
    },
    {
        modal_id: 'wiosna-i-jesien',
        title: '10. Wiosna i Jesień',
        thumbnail: 'img/ilustracje/wiosna-i-jesien-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/wiosna-i-jesien-1095x547.jpg',
                description: [
                    'Widok na Ziemię w dniach równonocy (około 21 IX i 21 III), z kierunku prostopadłego do prostej łączącej te położenia Ziemi. Słońce znajduje się pomiędzy oboma rysunkami. Dla obu dat, w południe, w każdym miejscu na Ziemi wysokości Słońca ponad horyzontem są takie same. Widać też, że w obu przypadkach (dla obu dat) w każdym miejscu Ziemi długość dnia jest równa długości nocy.'
                ]
            }
        ]
    },
    {
        modal_id: 'rozmiary-obrazow-gwiazd',
        title: '11. Rozmiary obrazów gwiazd',
        thumbnail: 'img/ilustracje/rozmiary-obrazow-gwiazd-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/rozmiary-obrazow-gwiazd-1100x719.jpg',
                description: [
                    'Wszystkie gwiazdy (poza Słońcem) są tak odległe, że nie możemy widzieć ich tarcz, więc wszystkie powinniśmy widzieć jako punkty. Punktami powinny również być ich obrazy rejestrowane na zdjęciach. Dlaczego więc obrazy gwiazd mają różną wielkość?'
                ]
            }
        ]
    },
    {
        modal_id: 'mglawica-leb-konia',
        title: '12. Mgławica Łeb Konia',
        thumbnail: 'img/ilustracje/mglawica-leb-konia-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/mglawica-leb-konia-1100x1082.jpg',
                description: [
                    'Zdjęcie mgławicy Łeb Konia wykonane w Australian Astronomical Obserwatory. Obraz dzieli, niemal na połowy, wertykalnie rozciągnięta, pofałdowana powierzchnia wielkiego gęstego obłoku, znajdującego się po lewej stronie. Gęstość gazu zewnętrznych części obłoku (z prawej strony) jest niewielka, jest on zjonizowany przez światło gwiazdy położonej po prawej stronie obłoku (poza zdjęciem). Gaz ten świeci i jest zarazem przejrzysty dla światła gwiazd położonych znacznie dalej. Wyraźnie widać różnicę pomiędzy liczbą gwiazd widocznych na tle obłoku (po lewej stronie zdjęcia) i obok niego, po prawej stronie zdjęcia. Swoją nazwę mgławica zawdzięcza bliższemu nam, wysuniętemu fragmentowi gęstego obłoku, widocznemu na tle bardziej odległego, świecącego gazu. Więcej <i class="fa fa-book" aria-hidden="true"></i>58, <a href="https://www.nasa.gov/multimedia/imagegallery/image_feature_2493.html"><i class="fa fa-television" aria-hidden="true"></i>98</a>.'
                ]
            }
        ]
    },
    {
        modal_id: 'wielka-mglawica-w-orionie',
        title: '13. Wielka Mgławica w Orionie – M42',
        thumbnail: 'img/ilustracje/wielka-mglawica-w-orionie-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/wielka-mglawica-w-orionie-1095x1432.jpg',
                description: [
                    'Niżej gwiazdozbiór Oriona z zaznaczonym położeniem najbardziej znanych obiektów widocznych w tym obszarze nieba. Wyżej zdjęcie mgławicy M42. W najjaśniejszym, tu niemal białym fragmencie tej mgławicy znajduje się grupa kilkudziesięciu bardzo młodych gwiazd (tzw. asocjacja), które powstały z gazu mgławicy. Gaz macierzystego obłoku jest pobudzany do świecenia promieniowaniem tych gwiazd. Cztery najjaśniejsze gwiazdy z tej grupy, położone blisko siebie, tworzą tzw. Trapez Oriona (tu są one widoczne jako jasna plamka). Zróżnicowanie barwne różnych fragmentów mgławicy jest wynikiem zróżnicowanego stopnia wzbudzania atomów gazu i obecności w obłoku atomów różnych pierwiastków. Więcej <i class="fa fa-book" aria-hidden="true"></i>60.'
                ]
            }
        ]
    },
    {
        modal_id: 'oblok-ciemnej-materii',
        title: '14. Obłok ciemnej materii "Worek węgla"',
        thumbnail: 'img/ilustracje/oblok-ciemnej-materii-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/oblok-ciemnej-materii-1100x1099.jpg',
                description: [
                    'Obłok ciemnej materii w gwiazdozbiorze Wężownika (Bernard 68). Brak gwiazd na jego tle wskazuje, że obłok ten jest względnie gęsty i znajduje się dość blisko. Więcej <i class="fa fa-book" aria-hidden="true"></i>57.'
                ]
            }
        ]
    },
    {
        modal_id: 'przestrzenny-rozklad-galatyk',
        title: '15. Przestrzenny rozkład galaktyk',
        thumbnail: 'img/ilustracje/przestrzenny-rozklad-galatyk-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/przestrzenny-rozklad-galatyk-1100x1137.jpg',
                description: [
                    'Fragment diagramu przedstawiającego rzeczywisty, przestrzenny rozkład ponad 200 tys. galaktyk, w cienkiej warstwie przestrzeni, w pobliżu równika niebieskiego. Każdy punkt na diagramie reprezentuje galaktykę. Najdalsze z nich znajdują się w odległości 2 miliardów lat świetlnych. Jest to rezultat kilku lat pracy wielu astronomów. Więcej informacji o tym programie obserwacyjnym: <a href="http://magnum.anu.edu.au/~TDFgg/"><i class="fa fa-television" aria-hidden="true"></i>99</a> '
                ]
            }
        ]
    },
    {
        modal_id: 'deep-field',
        title: '16. Deep Field',
        thumbnail: 'img/ilustracje/deep-field-thumb.jpg',
        images:[
            {
                image: 'img/ilustracje/deep-field-1100x1077.jpg',
                description: [
                    'To jedno z najbardziej niezwykłych zdjęć astronomicznych a zarazem najbardziej kosztownych. Wymagało kilkudziesięciu godzin pracy teleskopu Hubble’a. Powstało ze złożenia wielu osobnych kadrów. Obejmuje maleńki fragment nieba w gwiazdozbiorze Wielkiego Wozu – fragment, jaki przesłoniłoby drobniutkie ziarenko piasku (o średnicy 1/3 mm) trzymane w wyciągniętej ręce. Widać na nim tylko cztery gwiazdy z naszej Galaktyki (te, które są otoczone promykami). Wszystkie pozostałe obiekty – a jest ich około 3 tys. – są niesłychanie odległymi galaktykami. Odległość wielu z nich przekracza 5 miliardów lat światła; widzimy je więc takimi, jakimi były wtedy, gdy Słońce i Ziemia jeszcze nie istniały. Są pośród nich galaktyki eliptyczne, spiralne (jak nasza), soczewkowe i nieregularne. Zdjęcie to pozwala wyobrazić sobie, jak wyglądałoby nocne niebo, gdyby Układ Słoneczny znajdował się poza naszą Galaktyką, a nasze oczy zapewniły taką samą czułość na światło, jaką uzyskano na tym zdjęciu. Więcej <i class="fa fa-book" aria-hidden="true"></i>64.'
                ]
            }
        ]
        
    },
    {
        modal_id: 'wielka-mglawica-andromedy',
        title: '17. Wielka Mgławica Andromedy – M31',
        thumbnail: 'img/ilustracje/wielka-mglawica-andromedy-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/wielka-mglawica-andromedy-1095x1095.jpg',
                description: [
                    'Na mapce obejmującej duży fragment nieba (u góry) pokazane jest położenie galaktyki M31. Dla wszystkich, którzy chcieliby zobaczy ją na własne oczy, potrzebne będą zapewne dodatkowe wskazówki <i class="fa fa-certificate" aria-hidden="true"></i>90. Piękne zdjęcie tej galaktyki (widoczne niżej) wykonał Robert Gendler (<a href="http://www.robgendlerastropics.com/M31Page.html"><i class="fa fa-television" aria-hidden="true"></i>100</a>). Wielka Mgławica Andromedy jest galaktyką, rekordzistką pod względem rozmiarów kątowych. Kątowe rozmiary widocznej na zdjęciu błękitnej elipsy dysku sięgają 200 minut łuku (siedem tarcz Słońca bądź Księżyca).',
                    'Przyglądając się temu lub innym zdjęciom tej galaktyki, należy pamiętać o tym, że wszystkie widoczne na nich obiekty punktowe są gwiazdami należącymi do naszej Galaktyki. Błękitna mgła na obrzeżach dysku, a kremowa w centrum to zsumowane światło miliardów gwiazd, których z odległości ponad 2 milionów lat świetlnych nie sposób zobaczyć jako osobne punkty. Różnica barw centralnej części dysku i obszarów peryferyjnych jest przejawem różnicy pomiędzy średnią temperaturą powierzchni, a zarazem średnim wiekiem, gwiazd zasiedlających te rejony galaktyki. W centralnych obszarach procesy gwiazdotwórcze rozpoczęły się wcześniej, więc dominują tam gwiazdy stare o niższej temperaturze powierzchni – żółto-pomarańczowe <i class="fa fa-book" aria-hidden="true"></i>51. W zewnętrznych częściach dysku dominują gwiazdy młode o gorących powierzchniach – biało-błękitne. Uwagę zwracają również ciemne poszarpane sznury układające się koncentrycznie wokół jądra galaktyki. To obłoki materii międzygwiazdowej. Teraz to właśnie tam, w ich wnętrzach, zachodzą intensywne procesy gwiazdotwórcze. Więcej <i class="fa fa-book" aria-hidden="true"></i>65.'
                ]
            }
        ]
    },
    {
        modal_id: 'eagle-nebula',
        title: '18. "Eagle Nebula" (M16), "Pillars of Creation"',
        thumbnail: 'img/ilustracje/eagle-nebula-thumb.jpg',
        images:[
            {
                image: 'img/ilustracje/eagle-nebula-1099x4468.jpg',
                description: [
                    'Poniżej mapki nieba widoczne jest zdjęcie mgławicy Eagle Nebula (M16), wykonane w Australian Astronomical Obserwatory. Swoją widoczność zawdzięcza ona pobliskiej gromadzie gwiazd, widocznych na jej tle. Jest to grupa około 460 bardzo młodych (około miliona lat), masywnych (około 80 mas Słońca) i bardzo gorących gwiazd. Temperatura ich powierzchni sięga kilkudziesięciu tysięcy stopni. Moc świecenia niektórych spośród nich jest blisko milion razy większa od mocy świecenia Słońca. Światło gwiazd tej gromady pobudza do świecenia gaz zewnętrznych części wielkiego obłoku materii międzygwiazdowej. Na obrzeżach ciemnych, wydłużonych struktur widocznych w centrum mgławicy (ich długość sięga 10 lat świetlnych) utworzonych przez gęste, nieprzenikliwe dla świata, fragmenty większego obłoku (pokazanych w powiększeniu na środkowym zdjęciu ), nazywanych „Pillars of Creation”, trwają właśnie procesy formowania się nowych gwiazd. Procesy te zachodzą w niewielkich wrzecionowatych strukturach wskazanych strzałkami na najniższym zdjęciu. Rozmiary tych struktur znacznie przekraczają rozmiary Układu Słonecznego. Mgławica M16 jest odległa o około 7000 lat świetlnych.'
                ]
            }
        ]
    },
    {
        modal_id: 'plejady',
        title: '19. Plejady',
        thumbnail: 'img/ilustracje/plejady-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/plejady-1100x739.jpg',
                description: [
                    'Plejady to grupka kilkunastu jasnych, blisko siebie położonych gwiazd. Zwraca na nią uwagę każdy, kto choć przez chwilę zatrzyma wzrok na jesienno-zimowym niebie. Zajmują one obszar nieba porównywalny z rozmiarami tarczy Księżyca. Plejady są gromadą gwiazd, a dokładniej: otwartą gromadą gwiazd. Mgławica towarzysząca Plejadom jest najprawdopodobniej resztką obłoku, z którego powstały gwiazdy tej gromady. Nie jest jednak wykluczone, że mgławica ta nie ma genetycznego związku z gwiazdami gromady, lecz jest obłokiem mijanym przez Plejady w ich galaktycznej wędrówce. Plejady znajdują się w odległości około 400 lat świetlnych. Więcej <i class="fa fa-book" aria-hidden="true"></i>79.'
                ]
            }
        ]
    }
])
.factory('modalService',['$filter', 'modals_data', function( $filter, modals_data ) {
    var obj = {
        currentModal: null,
        setCurrentModal: function( modalID ) {
            this.currentModal = $filter('filter')( modals_data , { modal_id:modalID } )[0];
        }
    }
    return obj;
}]);

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[12]);


// WEBPACK FOOTER //
// main.bundle.js